//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
//  -- Components ---------------------
import { find, groupBy, get, map } from "lodash";
//  -- Constants ----------------------
import COLOR from "utils/constants/color";
import { TableBg } from "utils/assets/images";
import { CaretDownOutlined } from '@ant-design/icons';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
//  -- Features -----------------------


//  -- Thunks -------------------------

import { Select, Dropdown } from 'antd';
import { isEmpty } from 'lodash';
import moment from "moment-timezone";
import { useExams } from "store/exams/selectors";
import { handleListExamDataByConfig } from "store/exams/thunks";
import { handleGetFilterData, handleListGetSchool  , handleListTeacherClassSubmissions } from "store/organizations/thunks";
import { handleListCourseInfo } from "store/standardexams";
import ExamTableForDistrict from "./ExamTableForDistrict";
import Loading from "components/Loading";
import { DownloadOutlined } from '@ant-design/icons';
import { captureException } from '@sentry/react';
import { saveAs } from 'file-saver';
import OverallModal from 'containers/district_admin/OverallModal';
import queryString from 'query-string';
import { formatExportStudentId } from 'utils/formatExportStudentId';
const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;
const ACIFL_LEVEL_ABBR = ['AH ', 'AM', 'AL', 'IH', 'IM', 'IL', 'NH', 'NM', 'NL', 'FA']
const ACIFL_LEVEL = ['ADV HIGH ', 'ADV MID', 'ADV LOW', 'INTER HIGH', 'INTER MID', 'INTER LOW', 'NOVICE HIGH', 'NOVICE MID', 'NOVICE LOW', 'FALTANTES']
const EXAM_LABELS_FULL = ['Interpretativa(A)', 'Interpretativa(B)', 'Comprensión literaria', 'Comprensión auditiva', 'Comunicación interpersonal', 'Presentación oral informal']
const SECTION_MAX_POINTS = [20, 20, 12, 14, 17, 17]

const filterDistrictPreferenceExportGradesByActiveUser = (grades) =>
  (Array.isArray(grades) ? grades : []).filter((row) => row?.user?.active !== false);

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const SessionButton = styled.button`
    border: none;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;
    margin-right: 16px;
    height: 40px;
    // background: ${COLOR.green200};
    // color: #fff;
    padding-left: 12px;
    padding-right: 12px;
    // &:hover {
    //   background: ${COLOR.green1000};
    // }
`;

const Button = styled.button`
    border: none;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;
    margin-right: 16px;
    height: 40px;
    background: ${COLOR.green200};
    color: #fff;
    padding-left: 12px;
    padding-right: 12px;
    &:hover {
      background: ${COLOR.green1000};
    }
`;

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
  position: relative;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
//   justify-content: space-between;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
//   border: 2px solid ${COLOR.black100};
//   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;

const OverviewText = styled.span`
  color: black;
  font-size: 20px;
  font-weight: 800;
  display:flex !important;
  align-items:center;
`;

const NoAssignmentMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: ${COLOR.red};
  text-align: center;
  width: 100%;
`;

const ExamGradeSec = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-image:url(${TableBg});
    padding:16px;
    margin-bottom:60px;
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important;
    border: 1px solid #d9d9d9 !important; 
    background-color: rgb(237 237 237) !important;
    height: 40px !important;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .ant-select-dropdown {
   
  }
`;
const CloseWrapper = styled.div`
    position: absolute;
    right: 8px;
    width: fit-content;
`;


const SELECT_WIDTH = 270;
const default_combine ={
    question_length: [{
      exam1: '',
      exam2: '',
      exam3: ''
    }],
    grades: [
      {
        user: {},
        submissions:[{
          exam1: '',
          exam2: '',
          exam3: ''
        }]
      }
    ]
  }
  const EXAM_SCHOOLS = [{ value: 'high', label: 'HIGH SCHOOL' }, { value: 'middle', label: 'MIDDLE SCHOOl' }]
const SortingMenu = ({
  classData,
  onFilter,
  selected_class,
  disabled = false
}) => {
  const [selectedClass, setSelectedClass] = useState(null)
  useEffect(() => {
    setSelectedClass(selected_class)
  }, [selected_class])

  const onSelectCh = (txt) => {
    if (disabled) return;
    setSelectedClass(txt)
    onFilter(txt)
  }
  return (<div>
    <label htmlFor="schoolSelect" className="proficiencyExamDropdownLabel">
      CLASSES
    </label>
    <StyledSelect
      className="apExamSelect"
      showSearch
      bordered={false}
      placeholder={disabled ? "All selected" : "CLASSES"}
      style={{ width: SELECT_WIDTH, height:'40px' }}
      value={selectedClass}
      disabled={disabled}
      onChange={onSelectCh}
      options={classData}
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    /></div>)
}

const ProficiencyExam = ({
  currentOrg,
  schools
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingData, setLoadingData] = useState(false);
  const exams = useExams()
  const [activeSession, setActiveSession] = useState(null)
  const [resultData, setResultData] = useState({
    question_length:[],
    grades:[]
  })
  const [resultDataCombine, setResultDataCombine] = useState(default_combine)
  const [selected_school_type, setSelectedSchoolType] = useState('high')
  const [examTab, setExamTab] = useState('exam1')
  const [selected_teacher, setSelectedTeacher] = useState(null);
  const [selected_school, setSelectedSchool] = useState(null);
  const [selected_course, setSelectedCourse] = useState(null);
  const [selectedOrgTeacher, setSelectedOrgTeacher] = useState([])
  const [selected_class, setSelectedClass] = useState(null);
  const [selectedTeacherClasses, setSelectedTeacherClasses] = useState([])
  const [filterLoader, setFilterLoader] = useState(false)
  const [printloader, setPrintloader] = useState(false)
  const [allCourses, setAllCourses] = useState([]);
  const [courseInfo, setCourseInfo] = useState([]);
  const [selectedCourseForAll, setSelectedCourseForAll] = useState(null);
  const [allCourseClasses, setAllCourseClasses] = useState([]);
  const location = useLocation();
  const search = useMemo(() => queryString.parse(location.search), [location.search]);
    useEffect(() => {
        if(moment().get("month")<7){
            setActiveSession(downcomming_year) 
        }else{
            setActiveSession(upcomming_year)
        }
    }, [exams])
 

  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch(error) {
        captureException(`319 ProficiencyExam component: User not authenticated ${error}`);
        navigate("/");
      }
    }
    fetchData();
  }, []);
  async function fetchData() {
    const val = getExamValue(examTab);
    if (val === 'combine') {
      await onFilterFetchResultCombine(activeSession, selected_school_type, selected_school, selected_teacher);
    } else {
      await fetchForExam(activeSession, val, selected_school_type, selected_school, selected_teacher)
    }
  }
  useEffect(() => {
    if (activeSession) {
      if (selected_school === 'All') {
        if (selectedCourseForAll) {
          fetchData();
        }
      } else if (selected_school && selected_teacher && selected_class) {
        fetchData();
      }
    }
  }, [currentOrg, activeSession, selected_school, examTab, selected_teacher, selected_school_type, selected_class, selectedCourseForAll]);
  useEffect(() => {
    handleFetchSchools()
  }, [currentOrg]);

  useEffect(() => {
    const fetchCourseInfo = async () => {
      if (currentOrg?.id) {
        try {
          const result = await dispatch(handleListCourseInfo({ organisationId: currentOrg.id }));
          if (result?.data) {
            setCourseInfo(result.data);
          }
        } catch (error) {
          captureException(`Error fetching course info: ${error}`);
        }
      }
    };
    fetchCourseInfo();
  }, [currentOrg, dispatch]);

  const handleFetchSchools = async () => {
    try {
      if (!isEmpty(currentOrg)) {
        dispatch(handleListGetSchool(currentOrg.id));
      }
    } catch (error) {
      captureException(`320 Error fetching district data: ${error}`);
    }
  };


  const onExamTabClick = (txt) => {
    setExamTab(txt)
    // onFilterFetchResult('exams', txt)
}
  async function fetchForExam(session, e_type, s_level, school_id, teacher_id) {
    if (selected_school === 'All') {
      if (!selectedCourseForAll) return null;
    } else {
      if(!school_id || !teacher_id || !selected_class) return null;
    }
    setResultData({
      question_length:[],
      grades:[],
      assigned_activities_count: 0
    })
    setLoadingData(true);
    
    if (selected_school === 'All' && selectedCourseForAll) {
      const data = await dispatch(handleListExamDataByConfig({
        "session": session,
        "exam_type": String(e_type),
        "school_level": s_level,
        "id": currentOrg.id,
        school_id: null,
        teacher_id: null,
        class_id: null,
        course_id: selectedCourseForAll
      }));
      if (data && data.question_length) {
        setResultData({
          question_length: data.question_length || [],
          grades: data.grades || [],
          assigned_activities_count: data.assigned_activities_count || 0
        })
      }
    } else {
      const districtWideByCourse =
        selected_school !== 'All' && selected_class === 'All';
      const schoolIdForApi = districtWideByCourse
        ? null
        : school_id === 'all'
          ? null
          : school_id;
      const classIdForApi = districtWideByCourse ? null : selected_class;
      const data = await dispatch(handleListExamDataByConfig({
        "session": session,
        "exam_type": String(e_type),
        "school_level": s_level,
        "id": currentOrg.id,
        school_id: schoolIdForApi,
        teacher_id: teacher_id === 'all' ? null : teacher_id,
        class_id: classIdForApi
      }));
      if (data && data.question_length) {
        setResultData({
          question_length: data.question_length || [],
          grades: data.grades || [],
          assigned_activities_count: data.assigned_activities_count || 0
        })
      }
    }
    setLoadingData(false);
  }
  function combinePlaceholderTxt(txt) {
    switch (txt) {
      case 'NOT ASSIGNED':
        return 'NA'
      case 'NOT STARTED':
        return 'NS'
      case 'NOT FINISHED':
        return 'NF'
      default:
        break;
    }
    return ACIFL_LEVEL_ABBR[ACIFL_LEVEL.findIndex(k => k === txt)] || ''
  }
  async function onFilterFetchResultCombine(session, school_level, school_id, teacher_id) {
    if (selected_school === 'All') {
      if (!selectedCourseForAll) return null;
    } else {
      if(!school_id || !teacher_id || !selected_class) return null;
    }
    setResultDataCombine(default_combine);
    try {
      setLoadingData(true);
      const examTypes = ['1', '2', '3'];
      
      if (selected_school === 'All' && selectedCourseForAll) {
        const dataExams = await Promise.all(examTypes.map(exam_type =>
          dispatch(handleListExamDataByConfig({
            session,
            exam_type,
            school_level,
            "id": currentOrg.id,
            school_id: null,
            teacher_id: null,
            class_id: null,
            course_id: selectedCourseForAll
          }))
        ));
        if (dataExams[0]?.question_length) {
          const question_length = dataExams[0].question_length.map((_, i) => {
            const exam1 = Array.isArray(dataExams[0]?.question_length) ? dataExams[0].question_length[i] : 0;
            const exam2 = Array.isArray(dataExams[1]?.question_length) ? dataExams[1].question_length[i] : 0;
            const exam3 = Array.isArray(dataExams[2]?.question_length) ? dataExams[2].question_length[i] : 0;
            return { exam1, exam2, exam3 };
          });

          const grades = dataExams[0].grades.map(({ user, submissions }) => {
            const exam1Sub = find(dataExams[0]?.grades, ['user.id', user.id]);
            const exam2Sub = find(dataExams[1]?.grades, ['user.id', user.id]);
            const exam3Sub = find(dataExams[2]?.grades, ['user.id', user.id]);
            return {
              user,
              assignment_details_by_exam: {
                exam1: exam1Sub?.assignment_details || [],
                exam2: exam2Sub?.assignment_details || [],
                exam3: exam3Sub?.assignment_details || [],
              },
              submissions: submissions.map((_, i) => {
                const exam1Txt = exam1Sub?.submissions?.[i] || '';
                const exam2Txt = exam2Sub?.submissions?.[i] || '';
                const exam3Txt = exam3Sub?.submissions?.[i] || '';
                return {
                  exam1: i === 0 ? combinePlaceholderTxt(exam1Txt) : exam1Txt,
                  exam2: i === 0 ? combinePlaceholderTxt(exam2Txt) : exam2Txt,
                  exam3: i === 0 ? combinePlaceholderTxt(exam3Txt) : exam3Txt,
                };
              }),
            };
          });
    
          setResultDataCombine({ question_length, grades });
        }
      } else {
        const districtWideByCourse =
          selected_school !== 'All' && selected_class === 'All';
        const schoolIdForApi = districtWideByCourse
          ? null
          : school_id === 'all'
            ? null
            : school_id;
        const classIdForApi = districtWideByCourse ? null : selected_class;
        const dataExams = await Promise.all(examTypes.map(exam_type =>
          dispatch(handleListExamDataByConfig({
            session,
            exam_type,
            school_level,
            "id": currentOrg.id,
            school_id: schoolIdForApi,
            teacher_id: teacher_id === 'all' ? null : teacher_id,
            class_id: classIdForApi
          }))
        ));
    
        if (dataExams[0]?.question_length) {
          const question_length = dataExams[0].question_length.map((_, i) => {
            let exam1 = Array.isArray(dataExams)  && Array.isArray(dataExams[0]?.question_length) ? dataExams[0].question_length[i] : 0;
            let exam2 = Array.isArray(dataExams)  && Array.isArray(dataExams[1]?.question_length) ? dataExams[1].question_length[i]: 0;
            let exam3 = Array.isArray(dataExams)  && Array.isArray(dataExams[2]?.question_length) ? dataExams[2].question_length[i]: 0;
          
            
            return {
              exam1: exam1,
              exam2: exam2,
              exam3: exam3,
            }
          });
    
          const grades = dataExams[0].grades.map(({ user, submissions }) => {
            const exam1Sub = find(dataExams[0]?.grades, ['user.id', user.id]);
            const exam2Sub = find(dataExams[1]?.grades, ['user.id', user.id]);
            const exam3Sub = find(dataExams[2]?.grades, ['user.id', user.id]);
            return {
              user,
              assignment_details_by_exam: {
                exam1: exam1Sub?.assignment_details || [],
                exam2: exam2Sub?.assignment_details || [],
                exam3: exam3Sub?.assignment_details || [],
              },
              submissions: submissions.map((_, i) => {
                const exam1Txt = exam1Sub?.submissions?.[i] || '';
                const exam2Txt = exam2Sub?.submissions?.[i] || '';
                const exam3Txt = exam3Sub?.submissions?.[i] || '';
                return {
                  exam1: i === 0 ? combinePlaceholderTxt(exam1Txt) : exam1Txt,
                  exam2: i === 0 ? combinePlaceholderTxt(exam2Txt) : exam2Txt,
                  exam3: i === 0 ? combinePlaceholderTxt(exam3Txt) : exam3Txt,
                };
              }),
            };
          });
    
          setResultDataCombine({ question_length, grades });
        }
      }
    } catch (error) {
      captureException(`321 Error in data compose: ${error}`);
      console.error(error, "error in data compose");
    } finally {
      setLoadingData(false);
    }
  }
  
  const getExamValue = (key) => {
    const examMap = { exam1: '1', exam2: '2', exam3: '3', combined: 'combine' };
    return examMap[key] || 'combine';
  };


  
  const onSchoolTypeChange = (txt) => {
    setSelectedSchoolType(txt);

  };

  const school_option = useMemo(() => {
    const values = [{ label: 'All', value: 'All' }]
    if (!isEmpty(schools)) {
      values.push(...schools.filter(k => !k.demo).map(v => ({ label: v.displayName, value: v.id })))
    }
    return values;
  }, [schools])
  const exam_option = [
    {label: 'Exam1', value: 'exam1'},
    {label: 'Exam2', value: 'exam2'},
    {label: 'Exam3', value: 'exam3'},
    {label: 'Combined', value: 'combined'},
  ]
  const fetchTeacherClasses = async (teacher_id) => {
    setSelectedTeacherClasses([])
    setSelectedClass(null)
    setSelectedCourse(null)
    let highestSubmissionClass = null;
    let highestSubmissionInfo = {
      class_id: null,
      exam_id: null,
      school_level: null,
    }
    let data_set={
      class_selected: false,
      course_selected: false,
      exam_selected: false,
    }
    try {
       setFilterLoader(true);
       const submissionResult = await dispatch(handleListTeacherClassSubmissions({ teacher_id, session: activeSession }));
       if (submissionResult && submissionResult.statusCode===200) {
        highestSubmissionClass = submissionResult.data.reduce((max, curr) => {
          const currTotal = (curr.high_1 || 0) + (curr.high_2 || 0) + (curr.high_3 || 0) + (curr.middle_1 || 0) + (curr.middle_2 || 0) + (curr.middle_3 || 0);
          const maxTotal = (max.high_1 || 0) + (max.high_2 || 0) + (max.high_3 || 0) + (max.middle_1 || 0) + (max.middle_2 || 0) + (max.middle_3 || 0);
          return currTotal > maxTotal ? curr : max;
        }, { high_1: 0, high_2: 0, high_3: 0, middle_1: 0, middle_2: 0, middle_3: 0 });
      }
      if(highestSubmissionClass){
        const max_value_key = Object.keys(highestSubmissionClass).reduce((max, curr) => {
          return highestSubmissionClass[curr] > highestSubmissionClass[max] ? curr : max;
        }, 'high_1');
        if(typeof max_value_key === 'string'){
          highestSubmissionInfo.class_id = highestSubmissionClass.class_id;
          highestSubmissionInfo.exam_id = max_value_key.split('_')[1];
          highestSubmissionInfo.school_level = max_value_key.split('_')[0];
        }
      }
      const result = await handleGetFilterData(null, teacher_id, "classes")
      if (result && result.success) {
        const uniqueCourses = result.data?.reduce((acc, curr) => {
          if (!curr.course_info || !curr.course_info.id) {
            const noCourseEntry = acc.find(c => c.value === null);
            if (!noCourseEntry) {
              acc.push({label: 'No Course', value: null, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              noCourseEntry.classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          } else {
            if (!acc.find(c => c.value === curr.course_info.id)) {
              acc.push({label:curr.course_info.title, value:curr.course_info.id, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              acc.find(c => c.value === curr.course_info.id).classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          }
          return acc;
        }, [])
        setAllCourses(uniqueCourses || [])
        const courseInfo = result.data?.find(k=>k.id===highestSubmissionInfo.class_id)?.course_info;
        if(courseInfo){
          setSelectedCourse(courseInfo.id)
          data_set.course_selected = true;
        }
        if(highestSubmissionInfo?.class_id){
          const classInfo = result.data?.find(k=>k.id===highestSubmissionInfo.class_id);
          if(classInfo){
            setSelectedClass(classInfo.id)
            data_set.class_selected = true;
          }
        }
        if(highestSubmissionInfo.exam_id){
          setExamTab(`exam${highestSubmissionInfo.exam_id}`)
          data_set.exam_selected = true;
        }
        if(highestSubmissionInfo.school_level){
          setSelectedSchoolType(highestSubmissionInfo.school_level)
        }
        if (uniqueCourses && uniqueCourses.length > 0) {
          const firstCourse = uniqueCourses[0]
          if(!data_set.course_selected){
            setSelectedCourse(firstCourse.value)
            data_set.course_selected = true;
          }
          const firstClass = firstCourse.classes?.[0]
          if (firstClass) {
            if (!data_set.class_selected) {
              const classCount = firstCourse.classes?.length ?? 0;
              setSelectedClass(classCount > 1 ? 'All' : firstClass.id);
              data_set.class_selected = true;
            }
          }
        } else if (result.data && result.data.length > 0) {
          const s_class = result.data[0]
          if (s_class) {
            if(!data_set.class_selected){
              setSelectedClass(s_class.id)
              data_set.class_selected = true;
            }
          }
        }
        
        const dt = (result.data||[]).map(k=>({label:`${k.displayName ||''}`, value:k.id}))
        setSelectedTeacherClasses(dt|| [])
      }
    } catch (error) {
console.log(error, "error in fetching teacher classes")
    } finally{
       setFilterLoader(false);
    }
  }
  const fetchTeacher = async (orgId,activeTeacher) => {
    setSelectedOrgTeacher([])
    setSelectedTeacherClasses([])
    setSelectedClass(null)
    setSelectedTeacher(null)
    setFilterLoader(true);
    try {
      const result = await handleGetFilterData(orgId, null, "teacher")
      if (result && result.success) {
        const s_teacher = result.data?.[0];
        if(activeTeacher){
          const activeTeacherData = result.data.find(k=>k.id===activeTeacher)
          if(activeTeacherData){
            setSelectedTeacher(activeTeacherData.id)
            await fetchTeacherClasses(activeTeacherData.id)
          }
        }else{
          if (s_teacher) {
            setSelectedTeacher(s_teacher?.id)
            await fetchTeacherClasses(s_teacher?.id)
          }
        }
        const dt = (result.data||[]).map(k=>({label:`${k.firstName ||''} ${k.lastName ||''}`,value:k.id}))
        setSelectedOrgTeacher(dt)
      }
    } catch (error) {
        console.log(error.message , "error in fetching school teacher")
    } finally {
      setFilterLoader(false)
    }
  }
  useEffect(() => {
    const opt = school_option[1]
    if(search&&search.orgId){
      const val = school_option.find(k=>k.value==search.orgId)
      if(val){
        setSelectedSchool(val.value)
        fetchTeacher(val.value,search.teacherId)
        return;
      }
    }
    if (opt&&!selected_school) {
      setSelectedSchool(opt.value)
      fetchTeacher(opt.value)
    }
  }, [school_option,search]);



  const exam_data = useMemo(() => {
    return resultData
  }, [resultData])
  const exam_data_combine = useMemo(() => {
    return resultDataCombine
  }, [resultDataCombine])

  const filteredClassesByCourse = useMemo(() => {
    if (selected_school === 'All') {
      return [];
    }
    if (!selected_course || !allCourses || allCourses.length === 0) {
      return selectedTeacherClasses
    }
    const selectedCourseData = allCourses.find(c => c.value === selected_course)
    if (!selectedCourseData || !selectedCourseData.classes) {
      return selectedTeacherClasses
    }
    const sectionOpts = selectedCourseData.classes.map((cls) => ({
      label: cls.displayName || '',
      value: cls.id,
    }));
    return [{ label: 'All', value: 'All' }, ...sectionOpts];
  }, [selected_course, allCourses, selectedTeacherClasses, selected_school])

  const onSchoolSelect = async (v) => {
    if (v === 'All') {
      setSelectedSchool('All');
      setSelectedTeacher(null);
      setSelectedCourse(null);
      setSelectedClass(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      setSelectedOrgTeacher([]);
      setSelectedTeacherClasses([]);
    } else {
      setSelectedSchool(v);
      setSelectedTeacher(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      await fetchTeacher(v);
    }
  };

  const onCourseSelectForAll = async (courseId) => {
    setSelectedCourseForAll(courseId);
    setSelectedClass(null);
    if (!courseId) {
      setAllCourseClasses([]);
      setResultData({
        question_length:[],
        grades:[]
      });
      setResultDataCombine(default_combine);
      return;
    }
    try {
      setFilterLoader(true);
      const result = await dispatch(handleGetFilterData(currentOrg.id, null, "classes"));
      if (result && result.success && result.data) {
        const filteredClasses = result.data.filter(c => {
          if (courseId === null) {
            return !c.course_info || !c.course_info.id;
          }
          return c.course_info?.id === courseId;
        });
        const classIds = filteredClasses.map(c => c.id);
        setAllCourseClasses(classIds);
      }
    } catch (error) {
      captureException(`Error fetching classes for course: ${error}`);
    } finally {
      setFilterLoader(false);
    }
  };

  useEffect(() => {
    if (selected_school !== 'All') {
      return;
    }
    const first = courseInfo.find((c) => c?.id != null);
    if (!first) {
      return;
    }
    if (selectedCourseForAll != null && courseInfo.some((c) => c.id === selectedCourseForAll)) {
      return;
    }
    onCourseSelectForAll(first.id);
  }, [selected_school, courseInfo, selectedCourseForAll]);

  const getAciflPlacementExportTitle = (type, grades, combinedMode) => {
    const normalizePlacement = (value) => (value || '').toString().trim().toUpperCase();
    const isFallbackType = type === ACIFL_LEVEL[ACIFL_LEVEL.length - 1];
    const placementIndex = ACIFL_LEVEL.findIndex((level) => normalizePlacement(level) === normalizePlacement(type));
    const placementAbbr = placementIndex !== -1 ? ACIFL_LEVEL_ABBR[placementIndex] : null;
    const dt = {};
    const getCombinedPlacements = () => {
      const examKeys = ['exam1', 'exam2', 'exam3'];
      return (grades || []).flatMap((grade) =>
        examKeys.map((key) => grade?.submissions?.[0]?.[key] || 'NOT STARTED')
      );
    };
    const combinedPlacements = combinedMode ? getCombinedPlacements() : [];
    const totalStudent = combinedMode ? combinedPlacements.length : grades?.length || 0;
    let per = 0;

    if (isFallbackType) {
      let sub = 0;
      if (combinedMode) {
        combinedPlacements.forEach((placement) => {
          const normalizedPlacement = normalizePlacement(placement);
          if (
            normalizedPlacement &&
            normalizedPlacement !== 'NOT STARTED' &&
            normalizedPlacement !== 'NOT ASSIGNED' &&
            normalizedPlacement !== '-' &&
            normalizedPlacement !== 'NS' &&
            normalizedPlacement !== 'NA'
          ) {
            sub++;
          }
        });
      } else {
        (grades || []).forEach((g) => {
          const placement = g.submissions?.[0] || '';
          const normalizedPlacement = normalizePlacement(placement);
          if (
            normalizedPlacement &&
            normalizedPlacement !== 'NOT STARTED' &&
            normalizedPlacement !== 'NOT ASSIGNED' &&
            normalizedPlacement !== '-' &&
            normalizedPlacement !== 'NS' &&
            normalizedPlacement !== 'NA'
          ) {
            sub++;
          }
        });
      }
      per = totalStudent - sub > 0 ? (((totalStudent - sub) / totalStudent) * 100).toFixed(0) : 0;
    } else if (combinedMode) {
      combinedPlacements.forEach((placementValue) => {
        const normalizedPlacement = normalizePlacement(placementValue);
        if (dt[normalizedPlacement]) {
          dt[normalizedPlacement] += 1;
        } else {
          dt[normalizedPlacement] = 1;
        }
      });
      const normalizedType = normalizePlacement(type);
      const normalizedTypeAbbr = normalizePlacement(placementAbbr);
      const typeCount = (dt[normalizedType] || 0) + (normalizedTypeAbbr ? dt[normalizedTypeAbbr] || 0 : 0);
      if (typeCount > 0 && totalStudent > 0) {
        per = ((typeCount / totalStudent) * 100).toFixed(0);
      }
    } else {
      (grades || []).forEach((g) => {
        const placementValue = g.submissions?.[0] || 'NOT STARTED';
        const normalizedPlacement = normalizePlacement(placementValue);
        if (dt[normalizedPlacement]) {
          dt[normalizedPlacement] += 1;
        } else {
          dt[normalizedPlacement] = 1;
        }
      });
      const normalizedType = normalizePlacement(type);
      const normalizedTypeAbbr = normalizePlacement(placementAbbr);
      const typeCount = (dt[normalizedType] || 0) + (normalizedTypeAbbr ? dt[normalizedTypeAbbr] || 0 : 0);
      if (typeCount > 0 && totalStudent > 0) {
        per = ((typeCount / totalStudent) * 100).toFixed(0);
      }
    }

    if (per > 0) {
      return `${per}%`;
    }
    return '0%';
  };

  const applyDistrictProficiencyExportStyle = (worksheet) => {
    const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF02796D' } };
    const headerFont = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
    const borderThin = {
      top: { style: 'thin', color: { argb: 'FF000000' } },
      left: { style: 'thin', color: { argb: 'FF000000' } },
      bottom: { style: 'thin', color: { argb: 'FF000000' } },
      right: { style: 'thin', color: { argb: 'FF000000' } },
    };
    const metaRows = 2;
    const headerStartRow = metaRows + 2;
    const headerEndRow = metaRows + 1 + 4;
    const colCount = worksheet.columnCount || 1;
    for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
      const row = worksheet.getRow(rowIndex);
      const isMetaKey = rowIndex === 1;
      const isMetaVal = rowIndex === 2;
      const isHeaderBand = rowIndex >= headerStartRow && rowIndex <= headerEndRow;
      const isData = rowIndex > headerEndRow;
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderThin;
        if (isMetaKey) {
          cell.fill = headerFill;
          cell.font = headerFont;
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (isMetaVal) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
          cell.font = { size: 11 };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (isHeaderBand) {
          cell.fill = headerFill;
          cell.font = headerFont;
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (isData) {
          const useWhite = (rowIndex - (headerEndRow + 1)) % 2 === 0;
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: useWhite ? 'FFFFFFFF' : 'FFF5F5F5' },
          };
          cell.font = { size: 11 };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        }
      });
    }
    for (let c = 1; c <= colCount; c++) {
      const col = worksheet.getColumn(c);
      let max = 10;
      col.eachCell({ includeEmpty: false }, (cell) => {
        const len = cell.value != null ? String(cell.value).length : 0;
        if (len > max) max = Math.min(len, 50);
      });
      col.width = max + 2;
    }
  };

  const generateXLSFormatForCombinedExam = async () => {
    try {
      setPrintloader(true);
      
      const questionsRow = [
        'Questions per section:',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ];
      
      EXAM_LABELS_FULL.forEach((label, i) => {
        const questionLengths = exam_data_combine.question_length[i + 1] || {};
        questionsRow.push(questionLengths.exam1 || '-');
        questionsRow.push(questionLengths.exam2 || '-');
        questionsRow.push(questionLengths.exam3 || '-');
      });
      
      const maxPointsRow = [
        'Max points possible:',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ];
      
      EXAM_LABELS_FULL.forEach((label, i) => {
        maxPointsRow.push(SECTION_MAX_POINTS[i] || '');
        maxPointsRow.push(SECTION_MAX_POINTS[i] || '');
        maxPointsRow.push(SECTION_MAX_POINTS[i] || '');
      });
      
      const firstHeaderRow = [
        'Name',
        'Username',
        'Student Id',
        'Teacher Name',
        'School Name',
        'Exam 1',
        'Exam 2',
        'Exam 3',
      ];
      
      EXAM_LABELS_FULL.forEach((label, i) => {
        firstHeaderRow.push(label);
        firstHeaderRow.push('');
        firstHeaderRow.push('');
      });
      
      const secondHeaderRow = [
        '',
        '',
        '',
        '',
        '',
        'Placement',
        'Placement',
        'Placement',
      ];
      
      EXAM_LABELS_FULL.forEach(() => {
        secondHeaderRow.push('Exam 1');
        secondHeaderRow.push('Exam 2');
        secondHeaderRow.push('Exam 3');
      });
      
      const gradesForExportCombine = filterDistrictPreferenceExportGradesByActiveUser(
        exam_data_combine.grades,
      );
      const dataRows = [];
      gradesForExportCombine.forEach(({ user, submissions }) => {
        const placementData = submissions[0] || {};
        
        const row = [
          `${user.lastName || ""}, ${user.firstName || ""}`,
          user.username,
          formatExportStudentId(user.studentId),
          user.teacherName || "",
          user.schoolName || "",
          placementData.exam1 || '-',
          placementData.exam2 || '-',
          placementData.exam3 || '-',
        ];
        
        EXAM_LABELS_FULL.forEach((label, i) => {
          const sectionData = submissions[i + 1] || {};
          row.push(
            sectionData.exam1 || '-',
            sectionData.exam2 || '-',
            sectionData.exam3 || '-'
          );
        });
        
        dataRows.push(row);
      });
      
      const extraData = ACIFL_LEVEL.reduce((acc, type) => {
        acc[type] = getAciflPlacementExportTitle(type, exam_data_combine.grades, true);
        return acc;
      }, {});
      
      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Combined Proficiency');
      worksheet.addRow(Object.keys(extraData));
      worksheet.addRow(Object.values(extraData));
      worksheet.addRow([]);
      worksheet.addRow(firstHeaderRow);
      worksheet.addRow(questionsRow);
      worksheet.addRow(maxPointsRow);
      worksheet.addRow(secondHeaderRow);
      dataRows.forEach((r) => worksheet.addRow(r));

      const firstHeaderRowNum = 4;
      const questionsRowNum = 5;
      const maxPointsRowNum = 6;
      worksheet.mergeCells(firstHeaderRowNum, 6, firstHeaderRowNum, 8);
      EXAM_LABELS_FULL.forEach((label, i) => {
        const startCol = 9 + i * 3;
        worksheet.mergeCells(firstHeaderRowNum, startCol, firstHeaderRowNum, startCol + 2);
        worksheet.mergeCells(questionsRowNum, startCol, questionsRowNum, startCol + 2);
        worksheet.mergeCells(maxPointsRowNum, startCol, maxPointsRowNum, startCol + 2);
      });

      applyDistrictProficiencyExportStyle(worksheet);
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        `combined_proficiency ${moment().format("DD-MM-YY hh:mm:ss")}.xlsx`
      );

      setPrintloader(false);
    } catch (error) {
      captureException(`322 Error in combined exam XLS download: ${error}`);
      console.error("Error in combined exam XLS download:", error);
      setPrintloader(false);
    }
  };

  const generateCSVForCombinedExam = async () => {
    await generateXLSFormatForCombinedExam();
  };

  const generateCSV = async () => {
    if (examTab === "combined") {
      await generateCSVForCombinedExam();
      return;
    }

    try {
      setPrintloader(true);

      const questionsRow = [
        'Questions per section:',
        '',
        '',
        '',
        '',
        exam_data.question_length[0],
        '', // Empty for Overall section
        '', // Empty for Overall section
        '', // Empty for Overall section
      ];
      
      // Add question lengths for each EXAM_LABELS_FULL section
      EXAM_LABELS_FULL.forEach((label, i) => {
        questionsRow.push(exam_data.question_length[i + 1]);
        questionsRow.push(''); // Empty for merge
        questionsRow.push(''); // Empty for merge
      });
      
      // Build "Max points possible:" row
      const maxPointsRow = [
        'Max points possible:',
        '',
        '',
        '',
        '',
        '',
        '', // Empty for Overall section
        '', // Empty for Overall section
        '', // Empty for Overall section
      ];
      
      // Add max points for each EXAM_LABELS_FULL section
      EXAM_LABELS_FULL.forEach((label, i) => {
        maxPointsRow.push(SECTION_MAX_POINTS[i] || '');
        maxPointsRow.push(''); // Empty for merge
        maxPointsRow.push(''); // Empty for merge
      });
      
      // Build first header row with EXAM_LABELS_FULL at the top
      const firstHeaderRow = [
        'Name',
        'Username',
        'Student Id',
        'Teacher Name',
        'School Name',
        'Placement',
        'Overall', // Will be merged with next 2 columns
        '', // Empty for merge
        '', // Empty for merge
      ];
      
      // Add EXAM_LABELS_FULL to first row (each will span 3 columns via merge)
      EXAM_LABELS_FULL.forEach((label, i) => {
        firstHeaderRow.push(label);
        firstHeaderRow.push(''); // Empty for merge
        firstHeaderRow.push(''); // Empty for merge
      });
      
      // Build second header row with three sub-columns under each section
      const secondHeaderRow = [
        '',
        '',
        '',
        '',
        '',
        '',
        'Overall score',
        'Overall Points possible',
        'Overall Points earned',
      ];
      
      // Add three sub-columns for each EXAM_LABELS_FULL section
      EXAM_LABELS_FULL.forEach(() => {
        secondHeaderRow.push('overall score');
        secondHeaderRow.push('Overall points possible');
        secondHeaderRow.push('Overall points earned');
      });
      
      const gradesForExportSingle = filterDistrictPreferenceExportGradesByActiveUser(
        exam_data.grades,
      );
      const dataRows = [];
      gradesForExportSingle.forEach(({ user, submissions, grades_value = [] }) => {
        const overallData = grades_value[0] || {};
        
        const row = [
          `${user.lastName || ""}, ${user.firstName || ""}`,
          user.username,
          formatExportStudentId(user.studentId),
          user.teacherName || "",
          user.schoolName || "",
          submissions[0],
          overallData.overall_score !== null && overallData.overall_score !== undefined ? overallData.overall_score : '-',
          overallData.Overall_Points_possible !== null && overallData.Overall_Points_possible !== undefined ? overallData.Overall_Points_possible : '-',
          overallData.Overall_Points_earned !== null && overallData.Overall_Points_earned !== undefined ? overallData.Overall_Points_earned : '-',
        ];
        
        // Add section data with grades_value
        EXAM_LABELS_FULL.forEach((label, i) => {
          const sectionData = grades_value[i + 1] || {};
          row.push(
            sectionData.overall_score !== null && sectionData.overall_score !== undefined ? sectionData.overall_score : '-',
            sectionData.Overall_Points_possible !== null && sectionData.Overall_Points_possible !== undefined ? sectionData.Overall_Points_possible : '-',
            sectionData.Overall_Points_earned !== null && sectionData.Overall_Points_earned !== undefined ? sectionData.Overall_Points_earned : '-'
          );
        });
        
        dataRows.push(row);
      });
      
      const extraData = ACIFL_LEVEL.reduce((acc, type) => {
        acc[type] = getAciflPlacementExportTitle(type, exam_data.grades, false);
        return acc;
      }, {});
  
      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('proficiency');
      worksheet.addRow(Object.keys(extraData));
      worksheet.addRow(Object.values(extraData));
      worksheet.addRow([]);
      worksheet.addRow(firstHeaderRow);
      worksheet.addRow(questionsRow);
      worksheet.addRow(maxPointsRow);
      worksheet.addRow(secondHeaderRow);
      dataRows.forEach((r) => worksheet.addRow(r));

      const firstHeaderRowNum = 4;
      const questionsRowNum = 5;
      const maxPointsRowNum = 6;
      worksheet.mergeCells(firstHeaderRowNum, 7, firstHeaderRowNum, 9);
      EXAM_LABELS_FULL.forEach((label, i) => {
        const startCol = 10 + i * 3;
        worksheet.mergeCells(firstHeaderRowNum, startCol, firstHeaderRowNum, startCol + 2);
        worksheet.mergeCells(questionsRowNum, startCol, questionsRowNum, startCol + 2);
        worksheet.mergeCells(maxPointsRowNum, startCol, maxPointsRowNum, startCol + 2);
      });

      applyDistrictProficiencyExportStyle(worksheet);
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        `proficiency ${moment().format("DD-MM-YY hh:mm:ss")}.xlsx`
      );
    } catch (error) {
      captureException(`323 Error in exam gradebook download: ${error}`);
      console.error("Error in exam gradebook download:", error);
    } finally{
      setPrintloader(false)
    }
  };
  
  const proficiencyDownloadMenu = {
    items: [
      { key: 'xlsx', label: 'Download as XLSX' },
      { key: 'csv', label: 'Download as CSV' },
    ],
    onClick: () => {
      void generateCSV();
    },
  };

  const menuData = () => {
    return {
        items: map(Object.keys(groupBy(exams, "session")), x => ({
            key: x,
            label: (
                <PaddedBtn onClick={() => setActiveSession(x)}>{x}</PaddedBtn>
            ),
            style: { padding: '0px' }
        }))
    }
}
  return (
      <SentryWrap>
          <Wrapper className={"adminForm adminFormCstm adminFormCstm2"}>
            
              
              <ExamGradeSec className='proficiencyExamSpaceFromStart' >
              {/* Close Icon Button */}
              <CloseWrapper>
                <Link to="/proficiency-report">
                  <div style={{width:'25px', height:'25px', display:'flex', justifyContent:'center', alignItems:'center', zIndex:'1', cursor:'pointer', backgroundColor:'red', borderRadius:'100%'}} >
                    <CloseIcon  style={{width: 20, height: 20, color: "white"}} />
                  </div>
                </Link>
              </CloseWrapper>
              {resultData.assigned_activities_count == 0 ? (
                <NoAssignmentMessage>
                  No sections assigned to this session
                </NoAssignmentMessage>):null}
          
             <div style={{margin:'10px 0px'}}>
                    <OverviewText>1WAY&nbsp; <span style={{color:'#fb742b', fontSize:'22px', fontWeight:'800'}} > PROFICIENCY</span> </OverviewText>
                  </div>
              <div className="proficiencyExamSpace">
              
              <div style={{display:'flex', flexDirection:'row', gap:'10px', width:'100%', flexWrap:'wrap'}}>
                {/* SCHOOLS */}
                <div>
                  <label htmlFor="schoolSelect" className="proficiencyExamDropdownLabel">
                    SCHOOLS
                  </label>
                  <StyledSelect
                    className="apExamSelect"
                    defaultValue={selected_school}
                    style={{ width: SELECT_WIDTH, height:'40px' }}
                    showSearch
                    bordered={false}
                    value={selected_school}
                    placeholder={"SCHOOLS"}
                    options={school_option}
                    onChange={onSchoolSelect}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </div>

                {selected_school === 'All' ? (
                  <div>
                    <div>
                      <label htmlFor="courseSelectForAll" className="proficiencyExamDropdownLabel">
                        COURSES
                      </label>
                      <StyledSelect
                        className="apExamSelect"
                        value={selectedCourseForAll}
                        style={{ width: SELECT_WIDTH, height:'40px' }}
                        showSearch
                        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        options={courseInfo.map(c => ({ label: c.title, value: c.id }))}
                        onChange={(v) => {
                          onCourseSelectForAll(v)
                        }} 
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      <div>
                        <label htmlFor="teacherSelect" className="proficiencyExamDropdownLabel">
                          TEACHERS
                        </label>
                        <StyledSelect
                          className="apExamSelect"
                          defaultValue={'all'}
                          value={selected_teacher}
                          disabled={selected_school === 'All'}
                          style={{ width: SELECT_WIDTH, height:'40px' }}
                          showSearch
                          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                          options={selectedOrgTeacher}
                          onChange={(v) => {
                            setSelectedTeacher(v)
                            fetchTeacherClasses(v)
                          }} />
                      </div>
                    </div>

                    <div>
                      <div>
                        <label htmlFor="courseSelect" className="proficiencyExamDropdownLabel">
                          COURSES
                        </label>
                        <StyledSelect
                          className="apExamSelect"
                          defaultValue={'all'}
                          value={selected_course}
                          style={{ width: SELECT_WIDTH, height:'40px' }}
                          showSearch
                          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                          options={allCourses}
                          onChange={(v) => {
                            setSelectedCourse(v);
                            if (v && allCourses) {
                              const selectedCourseData = allCourses.find(c => c.value === v)
                              if (selectedCourseData && selectedCourseData.classes && selectedCourseData.classes.length > 0) {
                                setSelectedClass(selectedCourseData.classes.length > 1 ? 'All' : selectedCourseData.classes[0].id)
                              } else {
                                setSelectedClass(null)
                              }
                            } else {
                              setSelectedClass(null)
                            }
                          }} 
                          />
                      </div>
                    </div>
                  </>
                )}

                {/* SESSION */}
                <div>
                  <div>
                    <label htmlFor="sessionSelect" className="proficiencyExamDropdownLabel">
                      SESSION
                    </label>
                      {/* <StyledSelect
                        className="apExamSelect"
                        defaultValue={'all'}
                        value={selected_teacher}
                        style={{ width: SELECT_WIDTH, height:'40px' }}
                        showSearch
                        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        options={selectedOrgTeacher}
                        onChange={(v) => {
                          setSelectedTeacher(v)
                          fetchTeacherClasses(v)
                        }} /> */}
                      <Dropdown  menu={menuData()} placement="bottomLeft" trigger={['click']}>
                          <SessionButton style={{width: SELECT_WIDTH, height:'40px', borderRadius:'5px'}} onClick={e => e.preventDefault()}>
                              {activeSession ? activeSession : 'sessions'}
                              <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                          </SessionButton>
                      </Dropdown>
                  </div>
                </div>


              </div>
              {/* <OverallModal /> */}
              
              {/* <IconButton onClick={onDownload} style={{ padding: 0 }} aria-label="download pdf" disabled={printloader} className="no-print">
                
              </IconButton> */}
              </div>
              <div style={{display:'flex', flexDirection:'row', gap:'10px', flexWrap:'wrap'}}>
                

               
                {/* MIDDLE OR HIGH SCHOOL */}
                <div>
                  <div>
                    <label htmlFor="teacherSelect" className="proficiencyExamDropdownLabel">
                      MIDDLE OR HIGH SCHOOL
                    </label>
                    <StyledSelect
                      className="apExamSelect"
                      defaultValue={'high'}
                      value={selected_school_type}
                      style={{ width: SELECT_WIDTH, height:'40px' }}
                      showSearch
                      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                      options={EXAM_SCHOOLS}
                      onChange={(v) => {
                        setSelectedSchoolType(v)
                      }} 
                    />
                  </div>
                </div>

                {/* EXAMS */}
                <div>
                  <div>
                    <label htmlFor="examsSelect" className="proficiencyExamDropdownLabel">
                      EXAMS
                    </label>
                    <StyledSelect
                      className="apExamSelect"
                      defaultValue={'all'}
                      value={examTab}
                      style={{ width: SELECT_WIDTH, height:'40px' }}
                      showSearch
                      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                      options={exam_option}
                      onChange={(v) => {
                        onExamTabClick(v)
                      }} 
                      />
                  </div>
                </div>
                <SortingMenu
                    className="apExamSelect"
                    classData={filteredClassesByCourse}
                    selected_class={selected_class}
                    onFilter={(v) => {
                      setSelectedClass(v)
                  }} 
                  disabled={selected_school === 'All'}
                />
                <OverallModal />
                <div>
                  <Dropdown menu={proficiencyDownloadMenu} placement="bottomLeft" trigger={['click']}>
                    <Button 
                      style={{borderRadius:'5px', width: '150px', height:'40px', marginTop:'18px'}} 
                      className="apExamSelect" 
                      onClick={e => e.preventDefault()}
                    >
                      {printloader ? <Loading size={20} /> : <DownloadOutlined style={{ marginRight: '4px' }} />}
                      Download
                      <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                    </Button>
                  </Dropdown>
                </div>
              </div>
             <ExamTableForDistrict 
                dataLoading={loadingData||filterLoader}
                exams={exams}
                examType={examTab}
                onExamTabClick={onExamTabClick}
                resultData={exam_data}
                onSchoolTypeChange={onSchoolTypeChange}
                schoolType={selected_school_type}
                activeSession={activeSession}
                resultDataCombine={exam_data_combine}
                setActiveSession={setActiveSession}
             />
             </ExamGradeSec>
          </Wrapper>
      </SentryWrap>
  );
};


const mapStateToProps = (state) => ({
  classes: state.classes,
  currentOrg: state.currentOrg,
  schools: state.schools,
  users: state.users,
  allUser: state.allUser,
  allClasses: state.allClasses,
  distTeacher: state.distTeacher,
  distStudents: state.distStudents
});

export default connect(mapStateToProps, null)(ProficiencyExam);
